import { ActivityReferencePaletteProvider } from './ActivityReferencePaletteProvider';

export const ActivitiesReferenceContextPaletteModule = {
    __init__: ['referenceActivityPaletteProvider'],
    referenceActivityPaletteProvider: ['type', ActivityReferencePaletteProvider],
};
